export default __webpack_public_path__ + "static/media/4121599.f785a34b.jpg";